export default __webpack_public_path__ + "assets/access-denied.b1de86aa.svg";